import { render, staticRenderFns } from "./AddPaymentPage.vue?vue&type=template&id=4ba2009c&"
import script from "./AddPaymentPage.vue?vue&type=script&lang=js&"
export * from "./AddPaymentPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports